import React, { useState } from 'react';
import { Avatar, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { format, isSameDay, isValid } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { Draggable } from 'react-beautiful-dnd';
import api from '../../services/api';
import { getOpportunityValue, money } from './kanbanUtils';

const KanbanCard = ({ ticket, laneId, index, updateTicket, busy }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const contact = ticket.contact || {};
  const field = (contact.extraInfo || []).find(item => item.name === 'valor');
  const date = new Date(ticket.updatedAt);
  const time = isValid(date) ? format(date, isSameDay(date, new Date()) ? 'HH:mm' : 'dd/MM/yyyy') : 'Sem atualização';
  const channel = { whatsapp: 'WhatsApp', whatsapp_oficial: 'WhatsApp API', instagram: 'Instagram', facebook: 'Facebook' }[ticket.channel] || 'Atendimento';

  const save = async (remove = false) => {
    const value = Number(String(newValue).replace(',', '.'));
    if (!remove && (!newValue.trim() || !Number.isFinite(value) || value < 0)) {
      setError('Informe um valor válido, maior ou igual a zero.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      // The API replaces custom fields, so preserve the current collection.
      const { data: current } = await api.get(`/contacts/${contact.id}`);
      const extraInfo = (current.extraInfo || []).filter(item => item.name !== 'valor').map(({ id, name, value: fieldValue }) => ({ id, name, value: fieldValue }));
      if (!remove) extraInfo.push({ name: 'valor', value: value.toFixed(2) });
      const { data: updated } = await api.put(`/contacts/${contact.id}`, { extraInfo });
      updateTicket({ ...ticket, contact: { ...contact, extraInfo: updated.extraInfo || extraInfo } });
      setOpen(false);
    } catch (err) {
      setError('Não foi possível salvar o valor. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  return <>
    <Draggable draggableId={`card:${laneId}:${ticket.id}`} index={index} isDragDisabled={busy || open}>
      {(provided, snapshot) => <article className={`zk-card${snapshot.isDragging ? ' zk-card-dragging' : ''}`} ref={provided.innerRef} {...provided.draggableProps}>
        <div className="zk-card-meta">
          <span className="zk-ticket-id"><span className="zk-drag-handle" {...provided.dragHandleProps} aria-label={`Mover atendimento ${ticket.id}`}><DragIndicatorIcon fontSize="small" /></span>#{ticket.id}</span>
          <span className="zk-channel">{channel}</span>
        </div>
        <div className="zk-contact">
          <Avatar src={contact.urlPicture} className="zk-avatar">{(contact.name || '?').trim().split(/\s+/).slice(0, 2).map(word => word[0]).join('').toUpperCase()}</Avatar>
          <div><h3 title={contact.name}>{contact.name || 'Contato sem nome'}</h3><p>{contact.number || 'Sem telefone'}</p></div>
        </div>
        <div className="zk-message"><ChatBubbleOutlineIcon fontSize="small" /><p title={ticket.lastMessage || ''}>{ticket.lastMessage || 'Nenhuma mensagem registrada.'}</p></div>
        <div className="zk-card-tags"><span>{ticket.user?.name || 'Sem atendente'}</span>{ticket.queue?.name && <span>{ticket.queue.name}</span>}</div>
        <div className="zk-card-time"><time dateTime={isValid(date) ? date.toISOString() : undefined}>{time}</time>{Number(ticket.unreadMessages) > 0 && <span>{ticket.unreadMessages} não lidas</span>}</div>
        <footer className="zk-card-footer">
          <button type="button" className="zk-value" onClick={() => { setNewValue(field ? String(field.value) : ''); setError(''); setOpen(true); }}><span>Valor da oportunidade</span><strong>{field ? money(getOpportunityValue(ticket)) : 'Atribuir valor'}</strong></button>
          <Button className="zk-details" size="small" onClick={() => history.push(`/tickets/${ticket.uuid}`)}>Ver ticket</Button>
        </footer>
      </article>}
    </Draggable>
    <Dialog open={open} onClose={() => !saving && setOpen(false)} fullWidth maxWidth="xs" aria-labelledby={`value-title-${laneId}-${ticket.id}`} PaperProps={{ className: 'zk-value-dialog' }}>
      <DialogTitle id={`value-title-${laneId}-${ticket.id}`}>{field ? 'Editar valor' : 'Atribuir valor'}</DialogTitle>
      <DialogContent><p className="zk-dialog-help">Valor vinculado ao contato {contact.name}. A alteração também aparece nos outros cartões deste contato.</p><TextField autoFocus id={`value-input-${laneId}-${ticket.id}`} label="Valor da oportunidade (R$)" type="number" fullWidth variant="outlined" margin="dense" value={newValue} disabled={saving} inputProps={{ min: 0, step: '0.01' }} onChange={event => setNewValue(event.target.value)} error={!!error} helperText={error || 'Use duas casas decimais.'} /></DialogContent>
      <DialogActions>{field && <Button className="zk-remove-value" onClick={() => save(true)} disabled={saving}>Remover valor</Button>}<Button onClick={() => setOpen(false)} disabled={saving}>Cancelar</Button><Button className="zk-save-value" onClick={() => save()} disabled={saving}>{saving ? 'Salvando…' : 'Salvar'}</Button></DialogActions>
    </Dialog>
  </>;
};

export default KanbanCard;
